<template>
  <div class="wrap">
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
export default {
  name: "DefaultLayout",
  components: {
    Header,
    Footer,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/reset.css";
@import "@/assets/css/fonts.css";
@import "@/assets/css/common.css";
@import "@/assets/css/default.css";
</style>